export default {"src":"/_next/static/media/Products.e4b3fd7d.svg","height":84,"width":84,"blurWidth":0,"blurHeight":0};